import { TaskLabel } from '@seen/core/models/taskLabel/taskLabel'
import { forwardRef } from 'react'
import { DeletedTooltip } from '#src/components/DeletedLabelIndicator.tsx'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { RowBadge, type RowBadgeProps } from '#src/components/TaskRowBadge.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface LabelBadgeProps extends Omit<
  RowBadgeProps,
  'icon' | 'children'
> {
  label: string | undefined
  showDeleted?: boolean
}

export const LabelBadge = forwardRef<HTMLButtonElement, LabelBadgeProps>(
  ({ label: labelReference, showDeleted = false, ...delegated }, ref) => {
    const { data: label } = useRead(TaskLabel, labelReference)

    if (label?.isDeleted && !showDeleted) {
      return null
    }

    return (
      <DeletedTooltip isDeleted={label?.isDeleted ?? false}>
        <RowBadge
          icon={
            <LabelColor
              color={label?.color}
              className={label?.isDeleted ? 'opacity-50' : undefined}
            />
          }
          ref={ref}
          {...delegated}
        >
          <span className={label?.isDeleted ? 'opacity-50' : undefined}>
            {label?.name}
          </span>
        </RowBadge>
      </DeletedTooltip>
    )
  }
)
LabelBadge.displayName = 'LabelBadge'
